import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonArrayProperty,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'

export const IssueTypes = ['urgent', 'error', 'warning', 'info'] as const
export type IssueType = (typeof IssueTypes)[number]
export const IssueAreas = ['license', 'app-db', 'user', 'bo'] as const
export type IssueArea = (typeof IssueAreas)[number]

@jsonClass('Issue')
export class Issue {
	@jsonProperty(String)
	type!: IssueType
	@jsonProperty(String) description?: string
	@jsonProperty(String) area?: IssueArea
	@jsonProperty(String) subArea?: string
	@jsonProperty(String) suggestion?: string
	@jsonProperty(String) suggestionLink?: string

	constructor(init?: Partial<Issue>) {
		assignCommonProperties(this, init)
	}
}
